<template>
  <div class="login-container">
    <div class="login-box">
      <h1 class="login-title">材料清单系统</h1>
      
      <van-form @submit="handleLogin">
        <van-field
          v-model="username"
          name="username"
          label="用户名"
          placeholder="请输入用户名"
          :rules="[{ required: true, message: '请输入用户名' }]"
          clearable
        />
        
        <van-field
          v-model="password"
          type="password"
          name="password"
          label="密码"
          placeholder="请输入密码"
          :rules="[{ required: true, message: '请输入密码' }]"
          clearable
          :eye-icon="showPassword ? 'van-icon-hide' : 'van-icon-show'"
          @click-icon="showPassword = !showPassword"
        />
        
        <div class="login-actions">
          <van-button type="info" @click="isRegister = !isRegister" style="margin-right: 10px;">
            {{ isRegister ? '返回登录' : '立即注册' }}
          </van-button>
          <van-button type="primary" native-type="submit" :loading="loginLoading">
            {{ isRegister ? '注册' : '登录' }}
          </van-button>
        </div>
      </van-form>
    </div>
    
    <div class="login-footer">
      <a href="https://beian.miit.gov.cn/">渝ICP备2021005113号-1</a>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { authApi, saveTokens } from '../services/api'

export default {
  name: 'HomeView',
  data () {
    return {
      username: '',
      password: '',
      showPassword: false,
      isRegister: false,
      loginLoading: false
    }
  },
  components: {
  },
  mounted() {
    // 检查是否已登录，如果已登录直接跳转到列表页
    const accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      this.$router.push('/List')
    }
  },
  methods: {
    // 处理登录/注册
    async handleLogin(values) {
      if (this.loginLoading) return;
      
      this.loginLoading = true;
      
      try {
        if (this.isRegister) {
          // 注册
          const res = await authApi.register(this.username, this.password);
          if (res.success) {
            Toast.success('注册成功');
            this.isRegister = false;
          } else {
            Toast.fail(res.message || '注册失败');
          }
        } else {
          // 登录
          const res = await authApi.login(this.username, this.password);
          if (res.success) {
            Toast.success('登录成功');
            // 保存登录信息到localStorage
            saveTokens(res.accessToken, res.refreshToken, this.username);
            console.log('登录成功，保存的token:', { accessToken: res.accessToken, refreshToken: res.refreshToken });
            // 检查重定向URL
            const redirect = this.$route.query.redirect
            if (redirect) {
              this.$router.push(redirect)
            } else {
              this.$router.push('/List');
            }
          } else {
            Toast.fail(res.message || '登录失败');
          }
        }
      } catch (error) {
        console.error('操作失败:', error);
        // 获取具体的错误信息
        let errorMessage = this.isRegister ? '注册失败' : '登录失败';
        
        // 检查是否有详细的错误信息
        if (error && error.message) {
          errorMessage = error.message;
        } else if (error && error.error && error.error.message) {
          errorMessage = error.error.message;
        } else if (error && error.response && error.response.message) {
          errorMessage = error.response.message;
        }
        
        // 针对401错误，显示更具体的原因
        if (error && error.error && error.error.type) {
          switch (error.error.type) {
            case 'user_not_found':
              errorMessage = '用户不存在';
              break;
            case 'invalid_password':
              errorMessage = '密码错误';
              break;
            case 'missing_token':
              errorMessage = '缺少认证token';
              break;
            case 'invalid_token':
              errorMessage = '无效的认证token';
              break;
            case 'expired_token':
              errorMessage = '认证token已过期';
              break;
            default:
              break;
          }
        }
        
        Toast.fail(errorMessage);
      } finally {
        this.loginLoading = false;
      }
    }
  }
}
</script>
<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-box {
  width: 100%;
  max-width: 400px;
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.login-title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

.login-actions {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}

.login-footer {
  position: absolute;
  bottom: 10px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
}

.login-footer a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .login-box {
    padding: 20px;
  }
  
  .login-title {
    font-size: 20px;
    margin-bottom: 20px;
  }
}
  /* height: 100vh;
  background: url(../../public/bg.png) no-repeat fixed center;
  background-size: cover;
   backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(5px);
  filter: blur(5px);
  color: #fff;
  opacity: /* background-image: linear-gradient(180deg, #a1d0ff, #b3d8fd 40%, #ffffff 45%, #ffffff);
    0deg, blue, green 40%, red
  */
  
  .kl {font-size: 20px;
  font-weight: bold;
}

.digit {
  margin-top: 10px;
}

.csh {
  position: absolute;
  left: calc(50% - 150px);
  top: calc(50% - 100px);
  width: 300px;
  height: 200px;
}

.home::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url(../../public/bg.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  /* backdrop-filter: blur(10px);
  filter: blur(10px); */
  opacity: 0.1;
}

.bigBtn {

  font-family: Arial, Helvetica, sans-serif;
  font-size: 30px;
  line-height: 200px;
  color: #fff;
  position: absolute;
  left: calc(50% - 100px);
  top: calc(50% - 100px);
  width: 200px;
  height: 200px;
  border-radius: 10px;
  /* backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(5px); */
  background-image: linear-gradient(to bottom, #7cbeff, #48a3ff);
}

a {
  color: rgb(186, 186, 186);
  text-decoration: none;
  /* 防止下划线 */
}
</style>